<script setup lang="ts">
type Props = {
  /** Size in pixels */
  size?: number
}

withDefaults(defineProps<Props>(), {
  size: 16,
})
</script>

<template>
  <span class="loading-spinner" role="status">
    <span aria-hidden="true" class="spinner" :style="{ width: `${size}px`, height: `${size}px` }" />
    <span class="visually-hidden">Processing, please wait</span>
  </span>
</template>

<style scoped>
.loading-spinner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.spinner {
  display: inline-block;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
